<div class="p-grid">
  <!-- Left content -->
  <div class="p-col-12 p-md-6 left">
    <span #content>Left Content</span>
  </div>

  <!-- Top right content -->
  <div class="p-col-12 p-md-3 top">
    Top Right Content
  </div>

  <!-- Bottom right content -->
  <div class="p-col-12 p-md-3 bottom">
    Bottom Right Content
  </div>
</div>
